export const goToLogin = (service: string) => {
  window.open(`/login${service ? `?service=${service}` : ""}`, "_self");
};

export const goToSignUp = (service: string) => {
  window.open(`/signup${service ? `?service=${service}` : ""}`, "_self");
};
